var EnvNgApp;
(function (EnvNgApp) {
    var Core;
    (function (Core) {
        var Helpers;
        (function (Helpers) {
            var CultureHelper = /** @class */ (function () {
                function CultureHelper() {
                }
                CultureHelper.getCultureFromCurrency = function (currencyCode) {
                    var culture = null;
                    switch (currencyCode) {
                        case "USD":
                            culture = "en-US";
                            break;
                        case "EUR":
                            culture = "de-DE";
                            break;
                        case "PLN":
                            culture = "pl-PL";
                            break;
                        case "GBP":
                            culture = "en-GB";
                            break;
                    }
                    return culture;
                };
                return CultureHelper;
            }());
            Helpers.CultureHelper = CultureHelper;
        })(Helpers = Core.Helpers || (Core.Helpers = {}));
    })(Core = EnvNgApp.Core || (EnvNgApp.Core = {}));
})(EnvNgApp || (EnvNgApp = {}));
//# sourceMappingURL=culturehelper.js.map